import React from 'react';
import css from './index.module.less';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import icon0 from './icons/icon-0.svg';
import icon1 from './icons/icon-1.svg';
import icon2 from './icons/icon-2.svg';
import icon3 from './icons/icon-3.svg';
import icon4 from './icons/icon-4.svg';
import icon5 from './icons/icon-5.svg';
import icon6 from './icons/icon-6.svg';
import icon7 from './icons/icon-7.svg';

export default function WhatWeCover() {
  const { t } = useTranslation();
  // WhatWeCover 组件，展示服务覆盖的互联网范围
  const coverList = [
    { title: t('Search Engines'), icon: icon0 },
    { title: t('Social Media'), icon: icon1 },
    { title: t('Marketplaces'), subTile: '(basic)', icon: icon2 },
    { title: t('Video Sites'), icon: icon3 },
    { title: t('Dark Web'), icon: icon4 },
    { title: t('App Stores'), subTile: '(basic)', icon: icon5 },
    { title: t('Cyberlockers'), icon: icon6 },
    { title: t('Forums'), icon: icon7 },
  ];
  return (
    <div className={css.coverWrap}>
      <div className={css.content}>
        <div className={css.title}>{t('What we cover')}</div>
        <div className={css.subtitle}>
          {t('Our Impersonation Removal service covers every corner of the internet!')}
        </div>
        <div className={css.coverList}>
          {coverList.map((item) => (
            <div className={css.coverCard} key={item.title}>
              <Image className={css.icon} src={item.icon} width={28} height={28} alt="icon" />
              <div className={css.cardTitle}>
                <span>{item.title}</span>
                <span className={css.subCardTitle}>{item.subTile}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
